import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { EcosystemDiagram } from '../components/EcosystemDiagram';
import { AgreexaMark } from '../components/AgreexaMark';
import { Button } from '../components/Button';
export function About() {
  return <>
      <PageHeader eyebrow="About" title="An editorial mission, built on a trust infrastructure" intro="Home Independence Hub is the first official publication built on the Agreexa editorial trust ecosystem." data-id="element-212" />

      <section className="max-w-editorial mx-auto px-6 py-10 grid lg:grid-cols-2 gap-px bg-stone-200 rounded-sm overflow-hidden border border-stone-200" data-id="element-213">
        {/* Publication mission */}
        <div className="bg-white p-8 md:p-12" data-id="element-214">
          <p className="eyebrow text-trust-600 mb-4" data-id="element-215">Home Independence Hub</p>
          <h2 className="font-serif tracking-tightest text-ink text-2xl md:text-3xl" style={{
          fontWeight: 500
        }} data-id="element-216">
            Editorial Mission
          </h2>
          <div className="mt-5 space-y-4 text-stone-600 leading-relaxed" data-id="element-217">
            <p data-id="element-218">
              We help homeowners become more energy independent, more prepared
              and more self-sufficient — through editorial content, buying
              guides, product reviews, industry news and expert analysis.
            </p>
            <p data-id="element-219">
              Our coverage spans renewable energy, preparedness education, water
              independence and smart home technology. Whatever the topic, our
              obligation is to the reader first.
            </p>
            <p data-id="element-220">
              Every recommendation we publish follows the Agreexa Trust
              Framework® — so guidance is objective, transparent and genuinely
              useful.
            </p>
          </div>
        </div>

        {/* Agreexa infrastructure */}
        <div className="bg-ink text-paper p-8 md:p-12" data-id="element-221">
          <AgreexaMark tone="light" showTagline className="text-2xl mb-6" data-id="element-222" />
          <h2 className="font-serif tracking-tightest text-paper text-2xl md:text-3xl" style={{
          fontWeight: 500
        }} data-id="element-223">
            Trust Infrastructure
          </h2>
          <div className="mt-5 space-y-4 text-stone-300 leading-relaxed" data-id="element-224">
            <p data-id="element-225">
              Agreexa is an independent trust ecosystem whose mission is to help
              people make better purchasing decisions through transparent,
              evidence-based editorial evaluation.
            </p>
            <p data-id="element-226">
              Agreexa does not sell products. Agreexa builds trust. Every
              publication, recommendation, review and buying guide inside the
              ecosystem follows the Agreexa Trust Framework®.
            </p>
            <p data-id="element-227">
              Home Independence Hub is the flagship demonstrating that standard
              — with more authority publications to follow.
            </p>
          </div>
        </div>
      </section>

      {/* Future ecosystem */}
      <section className="max-w-editorial mx-auto px-6 py-20 md:py-24" data-id="element-228">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-229">
          <p className="eyebrow text-trust-600 mb-4" data-id="element-230">The Road Ahead</p>
          <h2 className="font-serif tracking-tightest text-ink text-3xl md:text-4xl" style={{
          fontWeight: 500
        }} data-id="element-231">
            A growing network of trusted publications.
          </h2>
        </div>
        <EcosystemDiagram data-id="element-232" />
        <div className="mt-14 text-center" data-id="element-233">
          <Button to="/agreexa-trust-framework" withArrow data-id="element-234">
            Read the Trust Framework
          </Button>
        </div>
      </section>
    </>;
}